export default __webpack_public_path__ + "static/media/launch_mailer.e1be21c7.png";